import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

const useLogoutUser = () => {
  const { auth } = useDispatch<Dispatch>();
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);

  return useCallback(() => {
    if (isDesktopEmbedded) {
      window.starsweb?.auth.logout();
      return;
    }
    auth.logout();
  }, [auth, isDesktopEmbedded]);
};

export default useLogoutUser;
